module.exports = __webpack_public_path__ + "img/awards_thirdplace.6a9824c4.png";